// Imports
import Vue from 'vue';
import Router from 'vue-router';
import AuthService from '@/services/auth';
import Store from '@/store';

Vue.use(Router);

// !!TODO Populate your TakeOver props here as necessary based on the samples below, depending on what you need
// We are using a constant here so we can configure the Auth Page props once because there are multiple paths 
// for these pages in the scenario below.
/*
const takeOverProps = {
};
*/

const dashboardProps = {
  drawerLogo: require(`/src/assets/large_logo.png`),
  drawerLogoMobile: require(`/src/assets/small_logo.png`),
  allowToggle: false,
  defaultOpen: false,
  mobileOnly: true,
  sideMenuConfig: {
    theme: {
      backgroundColor: 'white',
      textColor: 'rgba(0,0,0,.54)',
      activeColor: 'primary',
      activeTextColor: 'white',
    },
    items: [
      {
        label: 'Movement',
        routeName: 'Movement',
        icon: 'movement',
        displayCondition: 'users/displayMovementMenuItem',
      },
      {
        label: 'Workshop',
        routeName: false,
        icon: 'workshop',
        displayCondition: 'users/displayWorkshopGroupMenuItem',
        childrenToggle: true,
        childrenDefaultOpen: false,
        children: [
          {
            label: 'Adhoc Maintenance',
            routeName: 'Adhoc Maintenance',
            icon: 'adhocMaintenance',
            displayCondition: 'users/displayAdhocMaintenanceMenuItem',
          },
          {
            label: 'Daily Yard List',
            routeName: 'Daily Yard List',
            icon: 'dailyYardList',
            displayCondition: 'users/displayDailyYardListMenuItem',
          },
          {
            label: 'Job Cards',
            routeName: 'Job Cards',
            icon: 'jobCards',
            displayCondition: 'users/displayJobCardsMenuItem',
          },
          {
            label: 'Daily Planner',
            routeName: 'Daily Planner',
            icon: 'workshopSummary',
            displayCondition: 'users/displayDailyPlannerMenuItem',
          },
        ],
      },
      {
        label: 'Approvals',
        routeName: 'Approvals',
        icon: 'approvals',
        displayCondition: 'users/displayApprovalMenuItem',
      },
      {
        label: 'Vehicles',
        routeName: 'Vehicles',
        icon: 'vehicles',
        displayCondition: 'users/displayVehicleMenuItem',
      },
      {
        label: 'Drivers',
        routeName: false,
        icon: 'drivers',
        displayCondition: 'users/displayDriverGroupMenuItem',
        childrenToggle: true,
        childrenDefaultOpen: false,
        children: [
          {
            label: 'Types',
            routeName: 'Driver Types',
            icon: 'driverTypes',
            displayCondition: 'users/displayDriverTypeMenuItem',
          },
          {
            label: 'Routes',
            routeName: 'Driver Routes',
            icon: 'driverRoutes',
            displayCondition: 'users/displayDriverRouteMenuItem',
          },
          {
            label: 'Details',
            routeName: 'Driver Details',
            icon: 'drivers',
            displayCondition: 'users/displayDriverDetailsMenuItem',
          },
          {
            label: 'Rollouts',
            routeName: 'Driver Rollouts',
            icon: 'driverRollouts',
            displayCondition: 'users/displayDriverRolloutMenuItem',
          },
          {
            label: 'Payments',
            routeName: 'Driver Payments',
            icon: 'driverPayments',
            displayCondition: 'users/displayDriverPaymentMenuItem',
          },
          {
            label: 'Annual Leave',
            routeName: 'Annual Leave',
            icon: 'leave',
            displayCondition: 'users/displayDriverAnnualLeaveMenuItem',
          },
        ],
      },
      {
        label: 'Client Rates',
        routeName: false,
        icon: 'rates',
        displayCondition: 'users/displayClientRatesGroupMenuItem',
        childrenToggle: true,
        childrenDefaultOpen: false,
        children: [
          {
            label: 'Rate Sheets',
            routeName: 'Rate Sheets',
            icon: 'routeRates',
            displayCondition: 'users/displayRateSheetMenuItem',
          },
          {
            label: 'Rate Adjustments',
            routeName: 'Rate Adjustments',
            icon: 'rateAdjustments',
            displayCondition: 'users/displayRateAdjustmentsMenuItem',
          },
        ],
      },
      {
        label: 'Clients',
        routeName: 'Clients',
        icon: 'customers',
        displayCondition: 'users/displayClientMenuItem',
      },
      {
        label: 'Users',
        routeName: 'Users',
        icon: 'users',
        displayCondition: 'users/displayUserMenuItem',
      },
      {
        label: 'Bulk Messaging',
        routeName: 'Bulk Messaging',
        icon: 'bulkMessage',
        displayCondition: 'users/displayBulkMessagingMenuItem',
      },
      {
        label: 'Report Schedule',
        routeName: 'Report Schedule',
        icon: 'reportSchedule',
        displayCondition: 'users/displayReportScheduleMenuItem',
      },
      {
        label: 'Search',
        routeName: false,
        icon: 'search',
        displayCondition: 'users/displaySearchGroupMenuItem',
        childrenToggle: true,
        childrenDefaultOpen: false,
        children: [
          {
            label: 'Loads',
            routeName: 'Search Loads',
            icon: 'loads',
            displayCondition: 'users/displaySearchLoadsMenuItem',
          },
          {
            label: 'Driver Payments',
            routeName: 'Search Driver Payments',
            icon: 'driverPayments',
            displayCondition: 'users/displaySearchDriverPaymentsMenuItem',
          },
          {
            label: 'Rate Adjustments',
            routeName: 'Search Rate Adjustments',
            icon: 'rateAdjustments',
            displayCondition: 'users/displaySearchRateAdjustmentsMenuItem',
          },
          {
            label: 'Job Cards',
            routeName: 'Search Job Cards',
            icon: 'jobCards',
            displayCondition: 'users/displaySearchJobCardsMenuItem',
          },
        ],
      },
    ],
  },
  topMenuConfig: {
    theme: {
      backgroundColor: '#EEE',
      hoverColor: '#dfdfdf',
      activeColor: '#333',
    },
    items: [
      {
        label: 'users/loggedInUserDisplayName', // fetch this value from a store getter
        routeName: false,
        icon: 'profile',
        priority: true,

      },
      {
        label: 'LOGOUT',
        routeName: false,
        customEvent: 'SITE-LOGOUT',
        icon: 'logout',
      },
    ],
  },
};

// create object router with the valid initialization
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash };
    }
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
  routes: [
    // --- LOGIN PAGE ---
    {
      path: '/login',
      component: () => import('@/layouts/page/TakeOver.vue'),
      props: {
        variant: 'center',
        backgroundPath: require(`/src/assets/background.png`),
        headerStyle: 'banner',
        bannerPadding: 'py-10',
        titleColor: 'primary',
        headerColor: 'white',     
        logoPath: require(`/src/assets/large_logo.png`),
        copyrightText: (process.env.VUE_APP_COPYRIGHT).toUpperCase() + ' ' + process.env.VUE_APP_VERSION_NUMBER,
        copyrightColor: 'white',
        copyrightLocation: 'tight',
        menuItems: [
        ],
      },
      children: [
        {
          name: 'Login',
          path: '',
          component: () => import('@/views/Login.vue'),
        },
      ],
    },

    // --- LOGGED IN PAGES ---
    {
      path: '',
      component: () => import('@/layouts/page/Dashboard.vue'),
      beforeEnter: (to, from, next) => {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
            // check to see if the user is logged in
            // just call the checkAuth method. It will handle things if User is not Authed.  
            AuthService.checkAuth().then((response) => {
              next();
            });
        } else {
          next();
        }
      },
      props: dashboardProps,
      children: [
        // --- BLANK HOME PAGE ---
        {
          name: 'Overview',
          path: '',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Home.vue'),
        },
        // --- MOVEMENT PAGE ---
        {
          name: 'Movement',
          path: '/movement',
          meta: {
            requiresAuth: true,
            backLabel: 'Movement',
          },
          component: () => import('@/views/Movement.vue'),
        },
        // --- WORKSHOP PAGES ---
        {
          name: 'Adhoc Maintenance',
          path: '/workshop/adhoc-maintenance',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/AdhocMaintenance.vue'),
        },
        {
          name: 'Daily Yard List',
          path: '/workshop/daily-yard-list',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/DailyYardList.vue'),
        },
        {
          name: 'Job Cards',
          path: '/workshop/job-cards',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/JobCards.vue'),
        },
        // --- APPROVALS PAGE ---
        {
          name: 'Approvals',
          path: '/approvals',
          meta: {
            requiresAuth: true,
            backLabel: 'Approvals',
          },
          component: () => import('@/views/Approvals.vue'),
        },
        // --- VEHICLES PAGE ---
        {
          name: 'Vehicles',
          path: '/vehicles',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Vehicles.vue'),
        },
        // --- DRIVERS PAGES ---
        {
          name: 'Driver Types',
          path: '/driver-types',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/DriverTypes.vue'),
        },
        {
          name: 'Driver Routes',
          path: '/driver-routes',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/DriverRoutes.vue'),
        },
        {
          name: 'Driver Details',
          path: '/driver-details',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Drivers.vue'),
        },
        {
          name: 'Driver Rollouts',
          path: '/driver-rollouts',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/DriverRollouts.vue'),
        },
        {
          name: 'Driver Payments',
          path: '/payments',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/DriverPayments.vue'),
        },
        {
          name: 'Annual Leave',
          path: '/leave',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/DriversLeave.vue'),
        },
        // --- RATES PAGES ---
        {
          name: 'Rate Sheets',
          path: '/rate-sheets',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Routes.vue'),
        },
        {
          name: 'Rate Adjustments',
          path: '/rate-adjustments',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/RateAdjustments.vue'),
        },
        // --- CLIENTS PAGE ---
        {
          name: 'Clients',
          path: '/clients',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Customers.vue'),
        },
        // --- USERS PAGE ---
        {
          name: 'Users',
          path: '/users',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Users.vue'),
        },
        // --- BULK MESSAGING PAGE ---
        {
          name: 'Bulk Messaging',
          path: '/message',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/BulkMessaging.vue'),
        },
        // --- REPORT SCHEDULE PAGE ---
        {
          name: 'Report Schedule',
          path: '/report',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/ReportSchedule.vue'),
        },
        // --- SEARCH PAGES ---
        {
          name: 'Search Loads',
          path: '/search/loads',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Search_Loads.vue'),
        },
        {
          name: 'Search Driver Payments',
          path: '/search/payments',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Search_DriverPayments.vue'),
        },
        {
          name: 'Search Rate Adjustments',
          path: '/search/adjustments',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Search_RateAdjustments.vue'),
        },
        {
          name: 'Search Job Cards',
          path: '/search/job-cards',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Search_JobCards.vue'),
        },
        // LOAD PAGES
        {
          name: 'View Load',
          path: '/load/:id',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Load_View.vue'),
        },
        {
          name: 'Edit Load',
          path: '/load/edit/:id',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/Load_Edit.vue'),
        },
      ],
    },

    // --- WORKSHOP SUMMARY PAGE ---
    // --- This has been split out to use the full screen pdf layout
    {
      path: '/workshop/daily-planner',
      component: () => import('@/layouts/pdf/Index.vue'),
      beforeEnter: (to, from, next) => {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
            // check to see if the user is logged in
            // just call the checkAuth method. It will handle things if User is not Authed.  
            AuthService.checkAuth().then((response) => {
              next();
            });
        } else {
          next();
        }
      },
      props: {
      },
      children: [
        {
          name: 'Daily Planner',
          path: '',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/WorkshopSummary.vue'),
        },
      ],
    }
  ],
});

// export router as default
export default router;
